import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledMyFilesSubTitle = styled.span`
    display: flex;
    align-items: center;
    margin-bottom: 3.2rem;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 2rem;
    color: var(--color-grey-800);
    @media ${breakpoints.sm} {
        margin-bottom: 2.4rem;
        font-size: var(--size-14);
        line-height: 2.1rem;
    }
`;
